import React, { useEffect } from 'react'

// Components internal
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { SvgIcon, useTheme } from '@mui/material'

// Icons
import { ReactComponent as TouchAppIcon } from '../../../assets/layout/SelecioneProfessorIcon.svg'

// Others
import { themeApp } from '../../../themes'

// Components projects
import GridHeader from '../../../components/GridHeader'
import Image from '../../../components/Image'

// Images
import ComoFuncionaImage from '../../../assets/layout/ComoFuncionaBg.webp'
import ComoAlunoBgImage from '../../../assets/layout/ComoAlunoBg.webp'
import ComoProfessorImage from '../../../assets/layout/ComoProfessorBg.webp'

// Hooks
import { useAppDispatch, useAppSelector, useIsMounted } from '../../../hooks'

// Actions
import * as ContentsActions from '../../../store/ducks/Contents/actions'

/**
 * Página - Quem Somos
 */
const WhoWeArePage = (props) => {
  useEffect(() => {
    document.title = props?.title ? props.title : 'Fast Teachers - Aulas Particulares de Inglês'
  }, [props?.title])
  const appDispatch = useAppDispatch()
  const theme = useTheme()
  const content = useAppSelector((state) => state.contents)
  const isMounted = useIsMounted()

  React.useEffect(() => {
    if (isMounted) {
      appDispatch(ContentsActions.getContentRequest())
    }
  }, [isMounted])

  const getContent = () => content.data.find((r) => r.identifier === 'quem_somos')

  return (
    <Grid container display='flex' flexDirection='column'>
      <GridHeader
        header={{
          title: getContent()?.title,
          imgSrc: getContent()?.image_images?.original,
          imgFit: 'contain',
          text: (
            <>
              <Typography
                fontSize='18px'
                color='secondary.dark'
                mb={3}
                dangerouslySetInnerHTML={{ __html: getContent()?.content }}
              />
            </>
          ),
          defaultImage: {
            text: '240px x 400px',
            sx: {
              height: {
                xs: '100%',
                md: '15rem',
              },
              width: {
                xs: '100%',
                md: '25rem',
              },
            },
          },
        }}
      />
      {/* Section 2 */}
      <Box
        display='flex'
        alignItems='center'
        justifyContent='center'
        fontWeight='bold'
        fontStyle='italic'
        color='secondary.dark'
        sx={{
          height: {
            xs: '150px',
            md: '200px',
          },
          width: '100%',
          backgroundColor: 'primary.main',
          fontSize: {
            xs: '18px',
            lg: '32px',
          },
          p: {
            xs: '5px',
            lg: 0,
          },
        }}
      >
        Venha selecionar o seu professor de idiomas aqui{' '}
        <SvgIcon
          component={TouchAppIcon}
          inheritViewBox
          sx={{
            height: {
              xs: '50px',
              md: '60px',
            },
            width: {
              xs: '50px',
              md: '60px',
            },
          }}
        />
      </Box>
      {/* Section 4 */}
      <Box
        display='flex'
        justifyContent='center'
        sx={{
          width: {
            xs: '100%',
            md: 'auto',
          },
          my: {
            xs: '30px',
            lg: '60px',
          },
        }}
      >
        <Grid container maxWidth='lg' justifyContent='center'>
          <Grid item xs={12} lg={4} justifyContent='center' textAlign='center'>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
              flexDirection='column'
              sx={{
                position: {
                  xs: 'relative',
                  sm: 'inherit',
                },
              }}
            >
              <Image
                height='240px'
                width='100%'
                imageSrc={ComoFuncionaImage}
                defaultImageSize={{
                  height: '240px',
                  width: '100%',
                }}
                text='240px x 400px'
              />
              <Typography
                textAlign='center'
                textTransform='uppercase'
                color='secondary.dark'
                sx={{
                  width: {
                    xs: '100%',
                    sm: '310px',
                  },
                  backgroundColor: '#FFFFFF',
                  marginTop: '-40px',
                  fontSize: {
                    xs: '14px',
                    sm: '24px',
                    md: '28px',
                  },
                  zIndex: 1,
                  position: {
                    xs: 'absolute',
                    sm: 'inherit',
                  },
                  bottom: {
                    xs: -1,
                  },
                }}
              >
                Como Funciona a Plataforma
              </Typography>
            </Box>
            <Typography
              sx={{
                width: {
                  xs: '100%',
                  lg: '400px',
                },
                mx: 'auto',
                color: 'secondary.dark',
                fontSize: '16px',
                padding: '0px 10px',
              }}
            >
              <p>
                <b>A Fast Teachers Aulas Particulares de Inglês</b> ajuda alunos a encontrarem o seu professor
                de idiomas! E ajuda professores a serem encontrados! Cadastre-se para fazer sua aula
                experimental.
              </p>
            </Typography>
            <Button
              variant='contained'
              href='/como-funciona'
              sx={{
                height: {
                  xs: '35px',
                  md: '50px',
                },
                px: {
                  xs: '25px',
                  md: '50px',
                },
                borderRadius: '50px',
                fontSize: {
                  xs: '14px',
                  md: '18px',
                },
                fontWeight: 'bold',
                color: 'secondary.dark',
                mt: '20px',
                mb: {
                  xs: 3,
                  lg: 0,
                },
                border: `1px solid ${theme.palette.secondary.dark}`,
                '&:hover': {
                  backgroundColor: themeApp.hoverColor,
                  color: '#FFFFFF',
                  borderColor: 'primary.main',
                },
              }}
            >
              Quero Saber Mais
            </Button>
          </Grid>
          <Grid item xs={12} lg={4} justifyContent='center' textAlign='center'>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
              flexDirection='column'
              sx={{
                position: {
                  xs: 'relative',
                  sm: 'inherit',
                },
              }}
            >
              <Image
                height='240px'
                width='100%'
                imageSrc={ComoAlunoBgImage}
                defaultImageSize={{
                  height: '240px',
                  width: '100%',
                }}
                text='240px x 400px'
              />
              <Typography
                textAlign='center'
                textTransform='uppercase'
                color='secondary.dark'
                sx={{
                  width: {
                    xs: '100%',
                    sm: '310px',
                  },
                  backgroundColor: '#FFFFFF',
                  marginTop: '-40px',
                  fontSize: {
                    xs: '14px',
                    sm: '24px',
                    md: '28px',
                  },
                  zIndex: 1,
                  position: {
                    xs: 'absolute',
                    sm: 'inherit',
                  },
                  bottom: {
                    xs: -1,
                  },
                }}
              >
                Como Fazer Sua Aula Experimental
              </Typography>
            </Box>
            <Typography
              sx={{
                width: {
                  xs: '100%',
                  lg: '400px',
                },
                mx: 'auto',
                color: 'secondary.dark',
                fontSize: '16px',
                padding: '0px 10px',
              }}
            >
              <p>
                Cadastre-se para ter acesso aos perfis completos dos professores. Adquira o voucher
                e agende sua aula experimental. Avalie sua experiência para ajudar outros alunos e
                indique aos amigos.
              </p>
            </Typography>
            <Button
              variant='contained'
              href='/como-agendar-sua-aula-experimental'
              sx={{
                height: {
                  xs: '35px',
                  md: '50px',
                },
                px: {
                  xs: '25px',
                  md: '50px',
                },
                borderRadius: '50px',
                fontSize: {
                  xs: '14px',
                  md: '18px',
                },
                fontWeight: 'bold',
                color: 'secondary.dark',
                mt: '20px',
                mb: {
                  xs: 3,
                  lg: 0,
                },
                border: `1px solid ${theme.palette.secondary.dark}`,
                '&:hover': {
                  backgroundColor: themeApp.hoverColor,
                  color: '#FFFFFF',
                  borderColor: 'primary.main',
                },
              }}
            >
              Quero Ser Aluno
            </Button>
          </Grid>
          <Grid item xs={12} lg={4} justifyContent='center' textAlign='center'>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
              flexDirection='column'
              sx={{
                position: {
                  xs: 'relative',
                  sm: 'inherit',
                },
              }}
            >
              <Image
                height='240px'
                width='100%'
                imageSrc={ComoProfessorImage}
                defaultImageSize={{
                  height: '240px',
                  width: '100%',
                }}
                text='240px x 400px'
              />
              <Typography
                textAlign='center'
                textTransform='uppercase'
                color='secondary.dark'
                sx={{
                  width: {
                    xs: '100%',
                    sm: '310px',
                  },
                  backgroundColor: '#FFFFFF',
                  marginTop: '-40px',
                  fontSize: {
                    xs: '14px',
                    sm: '24px',
                    md: '28px',
                  },
                  zIndex: 1,
                  position: {
                    xs: 'absolute',
                    sm: 'inherit',
                  },
                  bottom: {
                    xs: -1,
                  },
                }}
              >
                Como Anunciar Suas Aulas
              </Typography>
            </Box>
            <Typography
              sx={{
                width: {
                  xs: '100%',
                  lg: '400px',
                },
                mx: 'auto',
                color: 'secondary.dark',
                fontSize: '16px',
                padding: '0px 10px',
              }}
            >
              <p>
                Preencha seu cadastro com perfil, experiência, especializações e o mais importante:
                disponibilize e gerencie datas disponíveis para aulas experimentais.
              </p>
            </Typography>
            <Button
              variant='contained'
              href='/como-anunciar-suas-aulas'
              sx={{
                height: {
                  xs: '35px',
                  md: '50px',
                },
                px: {
                  xs: '25px',
                  md: '50px',
                },
                borderRadius: '50px',
                fontSize: {
                  xs: '14px',
                  md: '18px',
                },
                fontWeight: 'bold',
                color: 'secondary.dark',
                mt: '20px',
                border: `1px solid ${theme.palette.secondary.dark}`,
                '&:hover': {
                  backgroundColor: themeApp.hoverColor,
                  color: '#FFFFFF',
                  borderColor: 'primary.main',
                },
              }}
            >
              Quero Ser Professor
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  )
}

export default WhoWeArePage
